/* DollarSense Theme JS */
(function () {
  'use strict';

  /* ---------- Slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (el) {
    var track = el.querySelector('[data-slideshow-track]');
    var slides = el.querySelectorAll('[data-slide]');
    var dots = el.querySelectorAll('[data-dot]');
    var index = 0, timer;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === index); });
    }
    function auto() { timer = setInterval(function () { go(index + 1); }, 5000); }
    function reset() { clearInterval(timer); auto(); }

    el.querySelector('[data-prev]') && el.querySelector('[data-prev]').addEventListener('click', function () { go(index - 1); reset(); });
    el.querySelector('[data-next]') && el.querySelector('[data-next]').addEventListener('click', function () { go(index + 1); reset(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); reset(); }); });
    if (slides.length > 1) auto();
  });

  /* ---------- Mobile menu ---------- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var menuClose = document.querySelector('[data-mobile-menu-close]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () { mobileMenu.hidden = false; });
    menuClose && menuClose.addEventListener('click', function () { mobileMenu.hidden = true; });
    document.addEventListener('click', function (e) {
      if (!mobileMenu.hidden && !mobileMenu.contains(e.target) && !menuToggle.contains(e.target)) mobileMenu.hidden = true;
    });
  }

  /* ---------- Predictive search ---------- */
  var searchInput = document.querySelector('[data-predictive-search-input]');
  var resultsBox = document.querySelector('[data-predictive-search-results]');
  if (searchInput && resultsBox) {
    var debounce;
    searchInput.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = searchInput.value.trim();
      if (q.length < 2) { resultsBox.hidden = true; return; }
      debounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            if (!products.length) {
              resultsBox.innerHTML = '<div class="predictive-search__empty">No results for &ldquo;' + q + '&rdquo;</div>';
            } else {
              resultsBox.innerHTML = products.map(function (p) {
                var price = p.price ? '$' + parseFloat(p.price).toFixed(2) : '';
                return '<a class="predictive-search__item" href="' + p.url + '">'
                  + (p.image ? '<img src="' + p.image + '" alt="">' : '')
                  + '<span>' + p.title + '</span>'
                  + '<span class="predictive-search__price">' + price + '</span></a>';
              }).join('');
            }
            resultsBox.hidden = false;
          })
          .catch(function () { resultsBox.hidden = true; });
      }, 250);
    });
    document.addEventListener('click', function (e) {
      if (!resultsBox.contains(e.target) && e.target !== searchInput) resultsBox.hidden = true;
    });
  }

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full');
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Variant picker ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsJson = document.querySelector('[data-product-variants]');
    if (variantsJson) {
      var variants = JSON.parse(variantsJson.textContent);
      var optionBtns = productForm.querySelectorAll('[data-option-value]');
      var idInput = productForm.querySelector('[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var compareEl = document.querySelector('[data-product-compare]');
      var savingEl = document.querySelector('[data-product-saving]');
      var stockEl = document.querySelector('[data-product-stock]');
      var addBtn = productForm.querySelector('[data-add-to-cart]');

      function money(cents) { return '$' + (cents / 100).toFixed(2); }

      function selectedOptions() {
        var opts = [];
        productForm.querySelectorAll('[data-option-group]').forEach(function (group) {
          var sel = group.querySelector('.is-selected');
          opts.push(sel ? sel.getAttribute('data-value') : null);
        });
        return opts;
      }

      function findVariant() {
        var opts = selectedOptions();
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function update() {
        var v = findVariant();
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          return;
        }
        idInput.value = v.id;
        if (priceEl) {
          priceEl.textContent = money(v.price);
          priceEl.classList.toggle('product__price--sale', !!v.compare_at_price && v.compare_at_price > v.price);
        }
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = money(v.compare_at_price);
            compareEl.style.display = '';
            if (savingEl) { savingEl.textContent = 'Save ' + money(v.compare_at_price - v.price); savingEl.style.display = ''; }
          } else {
            compareEl.style.display = 'none';
            if (savingEl) savingEl.style.display = 'none';
          }
        }
        if (stockEl) {
          if (!v.available) { stockEl.textContent = 'Sold out'; stockEl.style.color = 'var(--sold-out-color)'; }
          else if (v.inventory_quantity !== undefined && v.inventory_management && v.inventory_quantity <= 3) {
            stockEl.textContent = 'Low stock — order soon'; stockEl.style.color = 'var(--low-stock-color)';
          } else { stockEl.textContent = 'In stock'; stockEl.style.color = 'var(--in-stock-color)'; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
        var url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }

      optionBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var group = btn.closest('[data-option-group]');
          group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          update();
        });
      });
    }

    /* AJAX add to cart */
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          showCartMessage('Added to cart!');
        })
        .catch(function () { productForm.submit(); });
    });
  }

  /* ---------- Quantity buttons ---------- */
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      input.value = parseInt(input.value, 10) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var val = parseInt(input.value, 10);
      if (val > 1) { input.value = val - 1; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });

  /* ---------- Cart message toast ---------- */
  function showCartMessage(text) {
    var toast = document.createElement('div');
    toast.textContent = text;
    toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:var(--secondary-btn-bg,#222);color:#fff;padding:14px 28px;border-radius:6px;font-weight:700;z-index:9999;box-shadow:0 6px 20px rgba(0,0,0,.25)';
    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 2500);
  }
})();
